import React from "react";
import Protected from "./Protected";
import Login from "../../pages/Auth/Login";
import SignUp from "../../pages/Auth/SignUp";
import Forgot from "../../pages/Auth/Forgot";
import Reset from "../../pages/Auth/Reset";
import SurveyEntry from "../../pages/SurveyScan";
import LL55ScanSurvey from "../../pages/LL55SurveyScan";

export const Auth = {
  element: <Protected />,
  //   errorElement: <RouterErrorPage />,
  children: [
    {
      path: "/",
      element: <Login />,
    },
    {
      path: "/sign-up",
      element: <SignUp />,
    },
    {
      path: "/forgot-password",
      element: <Forgot />,
    },
    {
      path: "/reset-password",
      element: <Reset />,
    },
    {
      path: "/survey-form",
      element: <SurveyEntry />,
    },
    {
      path: "/ll55-survey-scan",
      element: <LL55ScanSurvey />,
    },
  ],
};
